/*
 *
 * OrgDeveloperPlanReducer reducer
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import produce from 'immer';
import { DevPlanMethod } from '../../store/signup/models';
export var initialState = {
    developerPlans: [],
    developerPlansOrg: '',
    developerPlans_loading: false,
    developerPlans_error: false,
    bundles: [],
    bundlesOrg: '',
    bundles_list_loading: false,
    bundles_list_error: false,
    activeBundles: [],
    activeBundlesOrg: '',
    active_bundles_loading: false,
    active_bundles_error: false,
    devPlanConsume: {},
    devPlanConsumeOrg: '',
    devPlanConsume_error: false,
    devPlanConsume_loading: false,
    devPlanInvoiceDetails: {},
    devPlanInvoiceDetailsOrg: '',
    devPlanInvoiceDetails_error: false,
    proRatedAmount: { details: {}, orgId: '', devPlanId: '' },
    proRatedAmount_loading: false,
    proRatedAmount_error: false,
    interval: DevPlanMethod.Annually,
    devPlanConsumablesCount: {},
    updatedAddons: [],
    resellerDetails: {},
    resellerDetailsOrg: '',
    proratedAmountForAddons: '',
    purchasedDeveloperPlan: {},
    developerPlanPurchase_loading: false,
    developerPlanPurchase_error: false,
    purchase_dev_plan_bundle_loading: false,
    purchase_dev_plan_bundle_error: false,
    devPlanCancel_loading: false,
    devPlanCancel_error: false,
    devPlanReactivate_loading: false,
    devPlanReactivate_error: false,
    purchase: false,
};
function OrgDeveloperPlanReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        var _a;
        switch (action.type) {
            case 'LOAD_ORG_DEVELOPER_PLAN_REQUEST':
                state.developerPlans_loading = true;
                state.developerPlans_error = false;
                break;
            case 'LOAD_ORG_DEVELOPER_PLAN_SUCCESS':
                state.developerPlans = action.developerPlans;
                var plan = action.developerPlans.find(function (e) { return e['active_dev_plan'] === true; });
                if (plan) {
                    state.interval = plan === null || plan === void 0 ? void 0 : plan.interval;
                }
                state.developerPlansOrg = action.developerPlansOrg || '';
                state.developerPlans_loading = false;
                state.developerPlans_error = false;
                break;
            case 'LOAD_ORG_DEVELOPER_PLAN_FAILURE':
                state.developerPlans_loading = false;
                state.developerPlans_error = true;
                break;
            case 'CHANGE_ORG_DEVELOPER_PLAN_INTERVAL_SUCCESS':
                state.interval = action.interval;
                state.developerPlans_loading = false;
                state.developerPlans_error = false;
                break;
            case 'LOAD_BUNDLES_REQUEST':
                state.bundles_list_loading = true;
                state.bundles_list_error = false;
                break;
            case 'LOAD_BUNDLES_SUCCESS':
                state.bundles = action.bundles;
                state.bundlesOrg = action.bundlesOrg || '';
                state.bundles_list_loading = false;
                state.bundles_list_error = false;
                break;
            case 'LOAD_BUNDLES_FAILURE':
                state.bundles_list_loading = false;
                state.bundles_list_error = true;
                break;
            case 'LOAD_ACTIVE_BUNDLES_REQUEST':
                state.active_bundles_loading = true;
                state.active_bundles_error = false;
                break;
            case 'LOAD_ACTIVE_BUNDLES_SUCCESS':
                console.log('action.ActiveBundles', action.ActiveBundles);
                state.activeBundles = action.ActiveBundles;
                state.activeBundlesOrg = action.activeBundlesOrg || '';
                state.active_bundles_loading = false;
                state.active_bundles_error = false;
                break;
            case 'LOAD_ACTIVE_BUNDLES_FAILURE':
                state.active_bundles_loading = false;
                state.active_bundles_error = true;
                break;
            case 'UPDATE_ACTIVE_BUNDLES_SUCCESS':
                state.activeBundles = action.selectedBundles;
                state.active_bundles_loading = false;
                state.active_bundles_error = false;
                break;
            case 'UPDATE_UPDATED_ADDONS_SUCCESS':
                state.updatedAddons = action.selectedBundles;
                break;
            case 'PURCHASE_DEV_PLAN_BUNDLES_REQUEST':
                state.purchase_dev_plan_bundle_loading = true;
                state.purchase_dev_plan_bundle_error = false;
                break;
            case 'PURCHASE_DEV_PLAN_BUNDLES_SUCCESS':
                state.purchase_dev_plan_bundle_loading = false;
                state.purchase_dev_plan_bundle_error = false;
                break;
            case 'PURCHASE_DEV_PLAN_BUNDLES_FAILURE':
                state.purchase_dev_plan_bundle_loading = false;
                state.purchase_dev_plan_bundle_error = true;
                break;
            case 'PURCHASE_ORG_DEVELOPER_PLAN_REQUEST':
                state.developerPlanPurchase_loading = true;
                state.developerPlanPurchase_error = false;
                state.purchase = false;
                break;
            case 'PURCHASE_ORG_DEVELOPER_PLAN_SUCCESS':
                state.purchase = true;
                if ((_a = action.purchasedDeveloperPlan) === null || _a === void 0 ? void 0 : _a.interval) {
                    state.interval = action.purchasedDeveloperPlan.interval;
                }
                state.purchasedDeveloperPlan = action.purchasedDeveloperPlan;
                state.developerPlans =
                    action.purchasedDeveloperPlan &&
                        state.developerPlans.map(function (item) {
                            return item.id === action.purchasedDeveloperPlan.id
                                ? __assign(__assign({}, item), { active_dev_plan: !item.active_dev_plan }) : __assign(__assign({}, item), { active_dev_plan: false });
                        });
                state.developerPlanPurchase_loading = false;
                state.developerPlanPurchase_error = false;
                break;
            case 'PURCHASE_ORG_DEVELOPER_PLAN_FAILURE':
                state.developerPlanPurchase_loading = false;
                state.developerPlanPurchase_error = true;
                state.purchase = false;
                break;
            case 'CANCEL_DEV_PLAN_REQUEST':
                state.devPlanCancel_loading = true;
                state.devPlanCancel_error = false;
                break;
            case 'CANCEL_DEV_PLAN_SUCCESS':
                state.devPlanCancel_loading = false;
                state.devPlanCancel_error = false;
                break;
            case 'CANCEL_DEV_PLAN_FAILURE':
                state.devPlanCancel_loading = false;
                state.devPlanCancel_error = true;
                break;
            case 'REACTIVATE_DEV_PLAN_REQUEST':
                state.devPlanReactivate_loading = true;
                state.devPlanReactivate_error = false;
                break;
            case 'REACTIVATE_DEV_PLAN_SUCCESS':
                state.devPlanReactivate_loading = false;
                state.devPlanReactivate_error = false;
                break;
            case 'REACTIVATE_DEV_PLAN_FAILURE':
                state.devPlanReactivate_loading = false;
                state.devPlanReactivate_error = true;
                break;
            case 'GET_DEV_PLAN_CONSUMED_REQUEST':
                state.devPlanConsume_loading = true;
                state.devPlanConsume_error = false;
                break;
            case 'GET_DEV_PLAN_CONSUMED_SUCCESS':
                state.devPlanConsume_loading = false;
                state.devPlanConsume = action.devPlanConsume;
                var _b = action.devPlanConsume, _c = _b.consumed, consumed = _c === void 0 ? {} : _c, _d = _b.available, available = _d === void 0 ? {} : _d;
                state.devPlanConsumablesCount = {
                    ios: available.ios - consumed.ios,
                    android: available.android - consumed.android,
                    pwa: available.pwa - consumed.pwa,
                    apps: available.apps - consumed.apps,
                };
                state.devPlanConsumeOrg = action.devPlanConsumeOrg || '';
                break;
            case 'GET_DEV_PLAN_CONSUMED_FAILURE':
                state.devPlanConsume_loading = false;
                state.devPlanConsume_error = true;
                break;
            case 'DEV_PLAN_INVOICE_DETAILS_SUCCESS':
                state.devPlanInvoiceDetails = action.devPlanInvoiceDetails;
                state.devPlanInvoiceDetailsOrg = action.orgId || '';
                break;
            case 'DEV_PLAN_INVOICE_DETAILS_FAILURE':
                state.devPlanInvoiceDetails_error = true;
                break;
            case 'GET_PRORATED_AMOUNT_REQUEST':
                state.proRatedAmount_loading = true;
                state.proRatedAmount_error = false;
                break;
            case 'GET_PRORATED_AMOUNT_SUCCESS':
                state.proRatedAmount_loading = false;
                state.proRatedAmount_error = false;
                state.proRatedAmount = {
                    details: action.details,
                    orgId: action.orgId || '',
                    devPlanId: action.devPlanId || '',
                };
                break;
            case 'GET_PRORATED_AMOUNT_FAILURE':
                state.proRatedAmount_loading = false;
                state.proRatedAmount_error = true;
                break;
            case 'GET_RESELLER_DETAILS_FOR_MANAGED_ORG_SUCCESS':
                state.resellerDetails = action.resellerDetails;
                state.resellerDetailsOrg = action.resellerDetailsOrg;
                break;
            case 'GET_PRO_RATED_AMOUNT_FOR_ADDONS_SUCCESS':
                state.proratedAmountForAddons = action.proratedAmountForAddons;
                break;
            default:
                break;
        }
    });
}
export default OrgDeveloperPlanReducer;
